var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _vm.prj
        ? _c(
            "div",
            [
              _c("h1", { staticClass: "text-center bot-blue" }, [
                _vm._v(_vm._s(_vm.prj.ProjectHost)),
              ]),
              _vm.keywordList.length
                ? _c("bot-table", {
                    attrs: {
                      dataSource: _vm.keywordList,
                      options: _vm.keyword.options,
                    },
                  })
                : _c(
                    "v-alert",
                    {
                      staticClass: "alert-message",
                      attrs: { type: "warning" },
                    },
                    [
                      _vm._v(
                        '\n            Dự án "' +
                          _vm._s(_vm.prj.ProjectTitle) +
                          '" chưa có từ khóa nào, hãy thêm từ\n            khóa!\n        '
                      ),
                    ]
                  ),
              _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-2",
                      attrs: { color: "primary" },
                      on: { click: () => _vm.updateKeyword(_vm.prj) },
                    },
                    [
                      _vm._v(
                        "\n                Thêm từ khóa\n                "
                      ),
                      _c("v-icon", { attrs: { right: "" } }, [
                        _vm._v(" mdi-plus-circle "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "v-alert",
            { staticClass: "alert-message", attrs: { type: "error" } },
            [
              _vm._v(
                "\n        Xin lỗi chúng tôi không tìm thấy dự án này!\n    "
              ),
            ]
          ),
      _c("link-ranking-item", {
        model: {
          value: _vm.selectedItem,
          callback: function ($$v) {
            _vm.selectedItem = $$v
          },
          expression: "selectedItem",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/views/link/ranking/link.ranking.list.vue